import React, { Component, useEffect, useState } from "react";
import { Menu as MenuDHX } from "dhx-suite";
import { Toolbar as ToolbarDHX } from "dhx-suite";
import { apiCall } from "../../../helpers/ApiCalls";
import ButtonAction from "../../globals/ButtonAction";
import { showAlert, showConfirm } from "../../globals/Message";
import { Row, Col } from "react-bootstrap";
import ls from "local-storage";
import styled from "styled-components";
import "./menu.css";
import "../../../dhtmlx/codebase/suite.css";
import { useHistory } from "react-router-dom";
import ModalDocumentacion from "../../globals/ModalDocumentacion";

const MenuContainer = styled(Row)`
  height: 5vh;
  background-color: #30333d;
  position: sticky;
  top: 0;
  z-index: 100;
  flex-wrap: nowrap;
  margin: 0;
  padding: 0;
  width: 100%;
  list-style: none;
  overflow: visible;
`;
const ColStyled = styled(Col)`
  margin: 0;
  overflow: hidden;
`;

class ToolbarMenu extends Component {
  componentDidMount() {
    let { data, toogleChange } = this.props;
    this.toolbar = new ToolbarDHX(this.el, {
      css: "menu-toolbar",
      navigationType: "pointer",
    });
    this.toolbar.data.parse(data ? data : []);

    this.toolbar.events.on("click", (id) => {
      toogleChange(this.toolbar.getState(), id);
    });
  }

  componentDidUpdate() {
    let { data } = this.props;

    this.toolbar.data.parse(data ? data : []);
  }
  componentWillUnmount() {
    this.toolbar && this.toolbar.destructor();
  }
  render() {
    return (
      <div
        style={{ width: "100%", height: "5vh" }}
        ref={(el) => (this.el = el)}
      ></div>
    );
  }
}

class Menu extends Component {
  componentDidMount() {
    let { css, data, navigationType } = this.props;
    this.menu = new MenuDHX(this.el, {
      css: css,
      navigationType,
    });
    this.menu.data.parse(data);
  }

  componentWillUnmount() {
    this.menu && this.menu.destructor();
  }

  render() {
    return (
      <div
        className={"menu-nav"}
        style={{
          width: "100%",
          height: "5vh",
          alignItems: "center",
          display: "flex",
        }}
        ref={(el) => (this.el = el)}
      ></div>
    );
  }
}

function MenuBar(props) {
  const [catalogos, setCatalogos] = useState([]);
  const [enManteniento, setEnMantenimiento] = useState(false);
  useEffect(() => {
    start();
  }, []);

  //regresar info
  function start() {
    if (ls.get("admin") === 1) {
      //obtenemos catalogos
      console.log("el token es ", ls.get("token"));
      apiCall("GET", "reporte/cat_proveedores").then((res) => {
        console.log("catatlogos", res);
        if (res.success && res.code === 200) {
          setCatalogos(res.data);
        }
      });
      //vemos si esta en mantenimiento el sistema
      apiCall("GET", "sistema/en_mantenimiento").then((res) => {
        if (res.success && res.code === 200) {
          setEnMantenimiento(res.data.status);
        }
      });
    }
  }

  const menuElments = [
    {
      type: "customHTML",
      css: "menu-title",
      html: `<img src='./gp.png' alt=''/>`,
    },
    {
      id: "title",
      type: "customHTML",
      css: "menu-titulo",
      html: '<span onClick="averQuepasa()">MarketPlace</span>',
    },
    {
      id: "title_proveedor",
      type: "customHTML",
      css: "menu-proveedor",
      html: "<span> - " + ls.get("proveedor") + "</span>",
    },
  ];
  let catalogo = [
    {
      type: "spacer",
    },
    {
      id: "title-proveedor",
      type: "title",
      value: "Proveedor:",
      css: "menu-toolbar-titulo",
    },
    {
      id: "ComboProveedor",
      type: "selectButton",
      value:
        ls.get("proveedor") === "Game Planet"
          ? "15089 - DISTRIBUCION LICENCIAS Y COMERCIALIZACION SA DE CV"
          : ls.get("proveedor"),
      items: catalogos.combo,
    },
  ];

  const menuElmentsAdmin = [
    {
      type: "customHTML",
      css: "menu-title",
      html: `<img src='./gp.png' alt=''/>`,
    },
    {
      id: "title",
      type: "customHTML",
      css: "menu-titulo",
      html: "<span>MarketPlace</span>",
    },
  ];

  function handleProveedor(data, id_elemento) {
    if (id_elemento !== "ComboProveedor") {
      ls.set("id_proveedor", id_elemento);
      ls.set("proveedor", data.ComboProveedor);
      window.location.reload();
    }
  }
  async function mandarMantenimiento() {
    await apiCall("POST", "sistema/set_mantenimiento", { status: 1 }).then(
      (res) => {
        if (res.success && res.code === 200) {
          setEnMantenimiento(true);
          showAlert(
            "Se a puesto el sistema en mantenimiento para todos los usuarios"
          );
        } else {
          showAlert(
            "Ocurrio un error, no se puee actualizar el estado del sistema"
          );
        }
      }
    );
  }
  function toggleMandarMantenimiento() {
    showConfirm(
      "Seguro de poner en mantenimiento, los usuarios no podran ingrsar y se cerrarán las sesiones actuales",
      "Si, Mandar a mantenimiento",
      () => {
        mandarMantenimiento();
      }
    );
  }

  async function levantarMantenimiento() {
    await apiCall("POST", "sistema/set_mantenimiento", { status: 0 }).then(
      (res) => {
        if (res.success && res.code === 200) {
          setEnMantenimiento(false);
          showAlert(
            "Se Levanto el mantenimiento, los usuarios pueden ingresar normalmente"
          );
        } else {
          showAlert(
            "Ocurrio un error, no se puee actualizar el estado del sistema"
          );
        }
      }
    );
  }
  function toggleLevanatrMantenimiento() {
    showConfirm(
      "Seguro de levantar el mantenimiento, los usuarios podran ingresar y usar MarketPlace normalmente.",
      "Si, levantar el mantenimiento",
      () => {
        levantarMantenimiento();
      }
    );
  }
  return (
    <MenuContainer id="menu-container">
      <ColStyled>
        <Menu
          css={"menu-nav"}
          //data={menuElmentsAdmin}
          data={ls.get("admin") === 1 ? menuElmentsAdmin : menuElments}
          navigationType={"click"}
          onClick={props.onClick}
        />
      </ColStyled>
      {ls.get("admin") === 1 ? (
        <>
          <ColStyled
            md={"auto"}
            className="d-flex align-items-center px-1"
            style={{ overflow: "visible" }}
          >
            <ModalDocumentacion
              title={"Documentación"}
              path={"market-place.md"}
              repo={"epod5"}
            />
            {enManteniento ? (
              <ButtonAction
                onClick={toggleLevanatrMantenimiento}
                showBadge={true}
                tooltip={"Levantar Mantenimiento"}
              >
                <span className="fa fa-cog" />
              </ButtonAction>
            ) : (
              <ButtonAction
                onClick={toggleMandarMantenimiento}
                tooltip={"Mandar a Mantenimiento"}
              >
                <span className="fa fa-cog" />
              </ButtonAction>
            )}
          </ColStyled>
          <ColStyled md={"auto"} className="pl-0">
            {
              <ToolbarMenu
                data={catalogo}
                multiselection={false}
                label={"Proveedor Actual"}
                labelPosition={"left"}
                selectAllButton={false}
                placeholder={"Proveedor"}
                toogleChange={handleProveedor}
              />
            }
          </ColStyled>
        </>
      ) : (
        <></>
      )}
    </MenuContainer>
  );
}
export default MenuBar;
